<template>
  <div>
    <v-toolbar flat color="white">
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog persistent v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.title"
                    label="Title"
                  ></v-text-field>
                  <v-text-field
                    v-model="editedItem.cloneTitle"
                    label="Clone"
                  ></v-text-field>
                  <v-combobox
                    v-model="editedItem.type"
                    :items="stainType"
                    solo
                    no-filter
                    label="Type"
                  ></v-combobox>
                  <v-autocomplete
                    v-model="editedItem.reactions"
                    :items="availableReactions"
                    label="Reactions"
                    item-text="title"
                    return-object
                    chips
                    clearable
                    solo
                    multiple
                  >
                  </v-autocomplete>
                  <v-autocomplete
                    v-model="editedItem.services"
                    :items="availableServices"
                    :item-text="item => `(${item.code}) ${item.title}`"
                    item-value="id"
                    chips
                    clearable
                    solo
                    multiple
                    label="Automatic order when using these services"
                  >
                  </v-autocomplete>
                  <v-combobox
                    v-model="editedItem.laboratories"
                    :items="availableLaboratories"
                    label="Laboratories"
                    item-text="title"
                    chips
                    clearable
                    solo
                    multiple
                  >

                    <template v-slot:selection="data">
                      <v-chip
                        :selected="data.selected"
                        close
                        @input="removeLaboratory(data.item)"
                      >
                        <strong>{{ data.item.title }}</strong
                        >&nbsp;
                      </v-chip>
                    </template>
                  </v-combobox>
                  <div v-for="lab in editedItem.laboratories" :key="lab.id">
                    <v-text-field
                      v-model="lab.bondId"
                      :mask="'#######'"
                      :label="`Bond Id for ${lab.title}`"
                    ></v-text-field>
                    <v-text-field
                      v-model="lab.ventanaId"
                      :label="`Ventana Id for ${lab.title}`"
                      type="number"
                    ></v-text-field>
                    <v-checkbox
                      v-model="lab.isAvailable"
                      :label="`Available stain for ${lab.title}`"
                    ></v-checkbox>

                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="availableStainsRiched"
      class="elevation-1"
      :search="search"
      :rows-per-page-items="[15, 30, 40]"
    >
      <template v-slot:items="props">
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.cloneTitle }}</td>
        <td>{{ props.item.type }}</td>
        <td>{{ props.item.laboratoriesText }}</td>
        <td>{{ props.item.reactionsText }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(props.item)">
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  name: 'stains',
  data: () => ({
    dialog: false,
    search: '',
    headers: [
      {
        text: 'Title',
        align: 'left',
        sortable: false,
        value: 'title'
      },
      {
        text: 'Clone',
        align: 'left',
        sortable: false,
        value: 'cloneTitle'
      },
      {
        text: 'Type',
        align: 'left',
        sortable: false,
        value: 'type'
      },
      {
        text: 'Laboratories',
        align: 'left',
        sortable: false,
        value: 'laboratoriesText'
      },
      {
        text: 'Reactions',
        align: 'left',
        sortable: false,
        value: 'reactionsText'
      },
      {
        text: 'Action',
        align: 'center',
        sortable: false
      }
    ],
    stainType: ['ihc', 'hc'],
    editedIndex: -1,
    editedItem: {
      id: null,
      title: '',
      cloneTitle: '',
      type: '',
      laboratories: null,
      reactions: null,
      services: null
    },
    defaultItem: {
      id: null,
      title: '',
      cloneTitle: '',
      type: '',
      laboratories: null,
      reactions: null,
      services: null
    }
  }),

  computed: {
    ...mapState({
      availableServices: 'availableServices',
      availableLaboratories: 'availableLaboratories',
      availableReactions: 'availableReactions',
      availableStains: 'availableStains'
    }),
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    availableStainsRiched() {
      let items = []

      for (let stain of this.availableStains) {
        items.push({
          ...stain,
          laboratoriesText: this.showLaboratories(stain.laboratories),
          reactionsText: this.showReactions(stain.reactions)
        })
      }

      return items
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  methods: {
    ...mapActions({
      stainCreate: 'stainCreate',
      stainUpdate: 'stainUpdate',
      stainDelete: 'stainDelete'
    }),

    showLaboratories(labs) {
      let data = _.map(labs, (item) => {
        let title = `${item.title}`
        if (item.bondId) {
          title = `${title}, Bond Id: ${item.bondId}`
        }
        if (item.ventanaId) {
          title = `${title}, Ventana Id: ${item.ventanaId}`
        }
        if (item.isAvailable) {
          title = `${title}, Available`
        }
        return title
      })

      return data.join(', ')
    },

    showReactions(reacts) {
      let data = _.map(reacts, (item) => {
        return `${item.title}`
      })

      return data.join(', ')
    },

    removeLaboratory(item) {
      this.editedItem.laboratories.splice(
        this.editedItem.laboratories.indexOf(item),
        1
      )
      this.editedItem.laboratories = [...this.editedItem.laboratories]
    },

    editItem(item) {
      this.editedIndex = _.findIndex(this.availableStains, stain => {
        return stain.id === item.id
      })
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.availableStains.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.stainDelete(item)
    },

    close() {
      this.dialog = false

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1

        for (let l of this.availableLaboratories) {
          l.bondId = null
          l.isAvailable = null
          l.ventanaId = null
        }
      }, 300)
    },

    save() {
      for (let value of this.editedItem.laboratories) {
        if (value.bondId) {
          value.bondId = parseInt(value.bondId)
        }
        if (value.bondId === '') {
          value.bondId = null
        }
        if (value.ventanaId) {
          value.ventanaId = parseInt(value.ventanaId)
        }
        if (value.ventanaId === '') {
          value.ventanaId = null
        }
      }
      if (this.editedIndex > -1) {
        this.stainUpdate(this.editedItem)
      } else {
        this.stainCreate(this.editedItem)
      }
      this.close()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/References/Stains.vue